export default __webpack_public_path__ + "static/dXcnUzzK-a1628a8a93be64ef7d362bae4491108d.svg";